import { QueryClient, useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { SERVER_ERRORS } from '@/common/constants';
import { API_URL } from '@/dtos';

import { EmployeePayload } from '../Employee.types';
import { GET_SSN_QUERY_KEY } from '../PersonalInformation/EmployerInfo/queries/useGetEmployeeSSN.query';
import { useHasSameSSNStore } from '../stores';

const useUpdateEmployeeQuery = () => {
  const queryClient = new QueryClient();
  const { setHasSameSSN } = useHasSameSSNStore();
  const { mutateAsync, isLoading } = useMutation(
    ({ id, ...value }: EmployeePayload) =>
      // TODO: DTO type is missing
      api.put<EmployeePayload>(API_URL.UI_EMPLOYEES_BY_EMPLOYEE_ID(id || ''), value),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [GET_SSN_QUERY_KEY],
        });
      },
      // TODO: Fix type
      // @ts-ignore
      onError: ({
        response: {
          data: { elevate_error_message },
          status,
        },
      }) => {
        if (
          status === SERVER_ERRORS.CONFLICT ||
          elevate_error_message?.includes('Employee with the same SSN and active status already exists')
        ) {
          setHasSameSSN();
        }
      },
    }
  );
  return {
    mutateAsync,
    isLoading,
  };
};

export default useUpdateEmployeeQuery;
